/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Nda_Pending_LinkInputs */



/**
* | output |
* | --- |
* | "Review and sign" |
*
* @param {Profile_Nda_Pending_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_nda_pending_link = /** @type {((inputs?: Profile_Nda_Pending_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Nda_Pending_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire et signer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leer y firmar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ler e assinar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggi e firma")
	return /** @type {LocalizedString} */ ("Review and sign")
});